<template>
  <div class="common-ad">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>展会设置</BreadcrumbItem>
          <BreadcrumbItem>联系人</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">联系人</div>
      </div>
    </div>
    <div class="common-down">
      <Row>
        <Col span="2">
        <p>联系人</p>
        </Col>
        <Col span="20">
        <div class="box">
          <div ref="editorElement2"></div>
        </div>
        </Col>
      </Row>
      <div class="f-tac" style="margin-top:30px">
        <Button type="primary" :loading="loading" @click="handleSubmit()">保存</Button>
      </div>
    </div>
  </div>
</template>

<script> 
import wangeditor from "wangeditor";
import axios from "axios";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "host-common-tip",
  components: {
    wangeditor,
  },
  data () {
    return {
      loading: false,
      editor: null,
      content: '',
      info: null,
    };
  },
  mounted () {
    this.init();
  },
  computed: {
    ...mapGetters({
      exhibition: "hostSetModule/getHostExhibition"
    }),
    exhibitionInfo () {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
  },
  methods: {
    ...mapActions({
      createExhibitionLink: "registerdModule/createExhibitionLink",
      getExhibitionLinkByExId: "registerdModule/getExhibitionLinkByExId",
      editExhibitionLink: "registerdModule/editExhibitionLink",
    }),
    init () {
      this.editor = new wangeditor(this.$refs.editorElement2);
      this.editor.customConfig.zIndex = 1;
      // 赋值
      this.editor.customConfig.onchange = e => {
        this.content = e;
      };

      // 上传图片配置
      const that = this;
      this.editor.customConfig.customUploadImg = function (files, insert) {
        files.forEach((item) => {
          let fd = new FormData();
          fd.append('file', item); // 上传的文件： 键名，键值
          axios.post(`${config.api.reqApi}/api/upload/images`, fd).then(data => {
            if (data.data.successed) {
              insert(data.data.list[0]);
            } else {
              that.$Message.error("上传失败，请重试！");
            }
          }).catch((err) => {
            that.$Message.error("上传失败，请重试！");
            console.log(err.response.data);
          });
        })
      }

      this.editor.customConfig.menus = [
        // 菜单配置
        'head', // 标题
        'bold', // 粗体
        'fontSize', // 字号
        'fontName', // 字体
        'italic', // 斜体
        'underline', // 下划线
        'strikeThrough', // 删除线
        'foreColor', // 文字颜色
        'backColor', // 背景颜色
        'link', // 插入链接
        'list', // 列表
        'justify', // 对齐方式
        'quote', // 引用
        'emoticon', // 表情
        'image', // 插入图片
        'table', // 表格
        'code', // 插入代码
        'undo', // 撤销
        'redo' // 重复
      ];
      this.editor.create(); // 创建富文本实例 
      this.editor.txt.html(this.content);
      this.getExhibitionLinkHandle();
    },
    async getExhibitionLinkHandle () {
      let res = await this.getExhibitionLinkByExId(this.exhibitionInfo.id);
      if (res) {
        this.info = res;
        this.content = res.text;
        if (this.editor) {
          this.editor.txt.html(this.content);
        }
      }
      console.log('getExhibitionLinkHandle', res);
    },
    async handleSubmit () {
      this.loading = false;
      setTimeout(() => {
        this.loading = true;
      }, 5000);
      console.log('content', this.content);
      let opt = {
        exhibitionId: this.exhibitionInfo.id,
        text: this.content,
      }
      let opt2 = {
        id: this.info ? this.info.id: '',
        setValues: {
          Text: this.content,

        }
      }
      let res = null;
      if (this.info) {
        res = await this.editExhibitionLink(opt2);
      } else {
        res = await this.createExhibitionLink(opt);
      }
      this.loading = false;
      if (res && res.successed) {
        this.$Message.success(`保存成功`);
      } else {
        this.$Message.error(`保存失败，请重试`);
      }
    },
    destroyed () {
      this.editor = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.common-down {
  padding: 40px;
  margin: 24px;
  background: #fff;
  min-height: 500px;
  min-width: 1000px;
  p {
    font-size: 16px;
  }
}
</style>